import React, { useReducer, createContext, useContext } from "react";
import { node, object } from "prop-types";

import reducer from "./reducer";
import { get } from "@Core/LocalStorage";
import { USERACCESS } from "@Constants/LocalStorage";
import initialUserState from "./initialUserState";

const getInitialState = () => {
  const localStorageData = JSON.parse(get(USERACCESS));
  if (localStorageData && typeof localStorageData === "object") {
    return {
      count: 0,
      ...localStorageData,
    };
  }
  return initialUserState;
};

export const UserContext = createContext(getInitialState());
export const UserbalContext = () => useContext(UserContext);

const UserProvider = (props) => {
  const { children, initialState } = props;
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: node.isRequired,
  initialState: object,
};

UserProvider.defaultProps = {
  initialState: getInitialState(),
};

export default UserProvider;
